import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    section: String,
    fieldName: String
  };

  connect() {
    this.handleClick = this.handleClick.bind(this);
    this.element.addEventListener("click", this.handleClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick);
  }

  handleClick(event) {
    const link = event.target.closest("a");
    if (!link) return;

    const isPagination = link.closest(".pagination") || link.closest(".pagination-container-custom") || link.closest("nav[role='navigation']");
    const isSort = link.closest("th");

    if (!isPagination && !isSort) return;

    const href = link.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("javascript:")) return;

    event.preventDefault();
    this.loadPage(link.href);
  }

  async loadPage(url) {
    this.element.classList.add("opacity-50", "pointer-events-none", "transition-opacity", "duration-150");

    try {
      const fetchUrl = new URL(url, window.location.origin);
      if (this.hasFieldNameValue) {
        fetchUrl.searchParams.set("field_name", this.fieldNameValue);
      }

      const response = await fetch(fetchUrl.toString(), {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      let newSection = null;
      if (this.element.id) {
        newSection = doc.getElementById(this.element.id);
      }
      if (!newSection && this.hasSectionValue) {
        newSection = doc.querySelector(`[data-async-table-section-value="${this.sectionValue}"]`);
      }

      if (newSection) {
        this.element.innerHTML = newSection.innerHTML;
        if (window.history && window.history.pushState) {
          window.history.pushState({ path: url }, "", url);
        }
      } else {
        window.location.href = url;
      }
    } catch (error) {
      console.warn("Async table update failed, falling back to full navigation:", error);
      window.location.href = url;
    } finally {
      this.element.classList.remove("opacity-50", "pointer-events-none");
    }
  }
}
